import {bool, string} from 'prop-types'
import {useFormContext} from "react-hook-form";
import {Stack} from "@bedrock-layout/stack";
import {Inline} from "@bedrock-layout/inline";
import React from "react";
import RadioField from "Components/molecules/RadioField";
import InputField from "Components/molecules/InputField";
import {Box, Link, Text} from "theme-ui";

const BrandingRadioGroup = ({disabled = false, variant}) => {
    const {watch} = useFormContext();
    const branding = watch("homePageConfiguration.branding.brandingType");
    const primaryColor = watch('homePageConfiguration.branding.details.primaryColor')
    const secondaryColor = watch('homePageConfiguration.branding.details.secondaryColor');


    return (
        <>
            <Text variant="label">Branding</Text>
            <Stack gutter="md" flexDirection="column">
                <RadioField
                    label="Tenant Branding"
                    name="homePageConfiguration.branding.brandingType"
                    value="tenant"
                    disabled={disabled}
                    readOnly={disabled}
                />

                {branding === 'tenant' &&
                <>
                    <Inline gutter="lg">
                        <Box>
                            <Stack gutter="md">
                                <InputField
                                    label="Primary"
                                    id="homePageConfiguration.branding.details.primaryColor"
                                    name="homePageConfiguration.branding.details.primaryColor"
                                    type="string"
                                    variant={variant}
                                    disabled={disabled}
                                />
                                <Box variant="colorSample" bg={`#${primaryColor}`}/>
                            </Stack>
                        </Box>
                        <Box>
                            <Stack gutter="md">
                                <InputField
                                    label="Secondary"
                                    id="homePageConfiguration.branding.details.secondaryColor"
                                    name="homePageConfiguration.branding.details.secondaryColor"
                                    type="string"
                                    variant={variant}
                                    disabled={disabled}
                                />
                                <Box bg={`#${secondaryColor}`} variant="colorSample"/>
                            </Stack>
                        </Box>

                    </Inline>
                    <Text my="2">Please ensure the colors are <Link href="https://www.w3.org/TR/WCAG21/"
                                                                    target="_blank">WCAG AA compliant</Link></Text>
                </>
                }
                <RadioField
                    label="Generic Branding"
                    name="homePageConfiguration.branding.brandingType"
                    value="generic"
                    disabled={disabled}
                    readOnly={disabled}
                />
            </Stack>
        </>
    );

};

BrandingRadioGroup.propTypes = {
  disabled: bool,
    variant: string
}

export default BrandingRadioGroup
